import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { ViewVariant } from "@/common/ts/layout";
import { CustomerDto } from "@/core/api/generated/v1";

import AssetSubscriptionPaginatedList from "../../../AssetSubscription/ListView/AssetSubscriptionPaginatedList";

interface Props {
  customer: CustomerDto;
}

export default function AssetSubscriptionsTabContent({ customer }: Props) {
  return (
    <PageTabContent>
      <Stack direction='column' spacing={2}>
        <AssetSubscriptionPaginatedList
          defaultValues={{
            customerId: customer.id!,
          }}
          displayProps={{
            viewVariant: ViewVariant.Tab,
            header: false,
            filters: true,
          }}
        />
      </Stack>
    </PageTabContent>
  );
}
